import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledLabel = styled.span`
  line-height: 18px;
`;

export const StyledList = styled.ul`
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 100%;
`;

export const StyledListItem = styled.li`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 6;
  cursor: pointer;
  padding: 2px 0;
  transition: all 0.25s ease;
  white-space: nowrap;
  line-height: 16px;
  font-weight: ${themeGet('fontWeights.regular')};
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.select.label')};

  &:not(:last-child) {
    margin-bottom: 3px;
  }

  > span {
    position: relative;
  }
`;

export const StyledOptions = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &.open {
    border-radius: ${themeGet('radii.base')} ${themeGet('radii.base')} 0 0;

    svg {
      transform: rotate(180deg);
        left: -30px!important;

    }
  }

  &.default {
    padding: 8px 12px;
    background-color: ${themeGet('colors.select.BgColor')};
    border-radius: ${themeGet('radii.base')};
    height: 32px;

    ${StyledLabel} {
      font-size: ${themeGet('fontSizes.sm')}px;
      font-weight: ${themeGet('fontWeights.regular')};
      color: ${themeGet('colors.select.label')};
      line-height: 16px;
    }
  }

  &.small {
    ${StyledLabel} {
      font-size: ${themeGet('fontSizes.base')}px;
      font-weight: ${themeGet('fontWeights.semi')};
      color: ${themeGet('colors.select.label')};
    }

    > svg {
      position: absolute;
      z-index: 6;
      left: -22px;
      color: ${themeGet('colors.select.label')};
    }
  }
`;

export const StyledDropdownWrapper = styled.div`
  &.is--disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  }

  &.is--open {
  }

  &.error {
    background-color: ${themeGet('colors.input.bgError')};

    ${StyledLabel} {
      color: ${themeGet('colors.input.textError')};
    }
  }

  &.default {
    position: relative;
    z-index: 5;

    ${StyledList} {
      padding: 8px 17px;
      border-radius: ${themeGet('radii.base')};
      background-color: ${themeGet('colors.select.BgColor')};
    }

    ${StyledListItem} {
      &.active {
        > span {
          color: ${themeGet('colors.white')};
        }

        > svg {
          position: relative;
        }

        &:before {
          position: absolute;
          left: -5px;
          top: 0;
          width: calc(100% + 10px);
          height: 100%;
          background-color: ${themeGet('colors.primary.regular')};
          border-radius: 20px;
          content: '';
          z-index: 0;
        }
      }

      &:hover {
        color: ${themeGet('colors.primary.regular')};
      }
    }
  }

  &.small {
    ${StyledList} {
      z-index: 5;
      right: -1px;
      left: auto;
      width: 105px;
      padding: 12px 19px 12px 38px;
      background-color: ${themeGet('colors.white')};
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: transparent ${themeGet('colors.text.border')}
        ${themeGet('colors.text.border')} ${themeGet('colors.text.border')};
      border-radius: ${themeGet('radii.small')};

      &:after {
        position: absolute;
        left: -1px;
        top: 0;
        width: 100%;
        content: '';
        height: 44px;
        background: ${themeGet('colors.white')};
      }
    }

    ${StyledListItem} {
      font-size: ${themeGet('fontSizes.base')}px;
      font-weight: ${themeGet('fontWeights.semi')};
      color: ${themeGet('colors.input.text')};
      text-align: right;

      &.active {
        color: ${themeGet('colors.primary.extra')};
      }

      &:not(:last-child) {
        margin-bottom: 6px;
      }
    }
  }
`;
